'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PERFORMANCE_START_STORY_ACTION = exports.PERFORMANCE_START_STORY_ACTION = 'PERFORMANCE_START_STORY_ACTION';
var PERFORMANCE_START_STORY_ACTION_SKIPPED = exports.PERFORMANCE_START_STORY_ACTION_SKIPPED = 'PERFORMANCE_START_STORY_ACTION_SKIPPED';

var performanceStartStoryAction = exports.performanceStartStoryAction = function performanceStartStoryAction(name, id, screenKey) {
  return {
    type: PERFORMANCE_START_STORY_ACTION,
    name: name,
    id: id,
    screenKey: screenKey
  };
};

var performanceStartStoryActionSkipped = exports.performanceStartStoryActionSkipped = function performanceStartStoryActionSkipped(name, id, screenKey) {
  return {
    type: PERFORMANCE_START_STORY_ACTION_SKIPPED,
    name: name,
    id: id,
    screenKey: screenKey
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/screen/actions/PerformanceStartStoryActionCreator.js
// module id = 758
// module chunks = 10